<template>
  <div class="data-table py-5" :class="{ 'new-design': newDesign }">
    <div v-if="!data.length" class="pt-6">
      <slot name="empty" />
    </div>
    <div v-else class="table-body">
      <div class="d-none d-lg-block">
        <div
          class="grid-table"
          :style="{ 'grid-template-columns': gridFractions }"
          style="background-color: #736D80"
        >
          <div
            v-for="(column, ic) in columns"
            :key="ic"
            class="text-white small font-weight-bold py-3 pl-3"
            :class="{ 'text-head': newDesign }"
          >
            {{ column }}
          </div>
        </div>
      </div>

      <div
        v-for="(item, index) in data"
        :key="index"
        class="grid-table item border-bottom mb-3 mb-lg-0"
        :style="{
          'grid-template-columns': gridFractions
        }"
      >
        <slot :item="item" :i="index" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    showSeparator: {
      type: Boolean,
      default: true
    },
    columns: {
      type: Array,
      default: () => []
    },
    data: {
      type: Array,
      default: () => []
    },
    firstColumnFr: {
      type: Number,
      default: 1
    },
    lastColumnFr: {
      type: Number,
      default: 0.5
    },
    columnsFr: {
      type: String,
      default: ""
    },
    newDesign: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    gridFractions() {
      const fr_list = Array(this.columns.length - 2)
        .fill("1fr")
        .join(" ");
      return this.columnsFr
        ? this.columnsFr
        : `${this.firstColumnFr}fr ${fr_list} ${this.lastColumnFr}fr`;
    }
  }
};
</script>

<style lang="scss" scoped>
.data-table {
  font-size: 14px;
  .grid-table {
    display: grid;

    @media screen and (min-width: 992px) {
      align-items: center;
    }
  }
  .item {
    & > * {
      padding: 8px;
    }

    &:nth-child(even) {
      background-color: #e5d6fd40;
    }
  }
  .crop {
    overflow: hidden;

    & > * {
      overflow: hidden;
      display: block !important;
      white-space: nowrap;
      text-overflow: ellipsis;
    }
  }
  ::v-deep .btn {
    padding: 0;
  }
  &.new-design {
    small {
      font-size: 14px !important;
    }

    strong {
      font-weight: 500 !important;
      color: rgba(59, 59, 74, 0.9);
    }
    .item {
      & > * {
        padding: 16px 8px 16px 0;
        &:last-child {
          padding: 8px 0px;
        }
      }
      &:nth-child(even) {
        background-color: unset;
      }
    }
    .grid-table {
      @media screen and (max-width: 991px) {
        grid-template-columns: 1fr auto !important;
        grid-auto-columns: auto !important;
      }
      &:not(.item) {
        background-color: unset !important;
      }
    }

    ::v-deep {
      .actions-dropdown {
        .btn {
          height: unset;
          min-height: unset;
        }
      }
    }
  }

  .text-head {
    color: rgba(38, 36, 50, 0.928) !important;
    font-size: 14px;
    font-weight: 500 !important;
    line-height: 20px;
    padding: 8px 8px 8px 0 !important;
    &:first-child {
      padding: 8px 8px 8px 0;
    }
    &:last-child {
      padding: 8px 0 8px 8px;
    }
  }
  .responsive-table {
    flex: 1;
    row-gap: 8px;
    display: flex;
    overflow: hidden;
    flex-direction: column;
  }
}
</style>
